module.exports = __webpack_public_path__ + "static/services-1-66695df29272bf64f542f23358c1eb36.jpg";